














import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class UnitSummary extends Vue {
  private header = "WHO WE ARE";
  private text =
    "Welcome to our vibrant gaming community, home to a thriving ArmA 3 unit. " +
    "We share a passion for casual gaming as a way to unwind and connect " +
    "with one another. Our community has developed a custom mod system that " +
    "allows for seamless integration of user-created missions into our " +
    "server. This way we can play many different mod packs and settings, as " +
    "long as they are available on the workshop. At our core, we prioritize " +
    "spending our free time by having fun and fostering a supportive " +
    "community. If this sounds like the kind of environment you'd like to be a " +
    "part of, don't hesitate to join our Discord server. We look forward to welcoming you! ";
}
